import { API_ENDPOINT } from "@/constants/appConstants";

const BasicHeader = ({ hostname }: { hostname: string; isMobile: boolean }) => {
  return (
    <header className="z-50 w-full border bg-white">
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-0 lg:w-[85%!important]">
        <img
          src={`${API_ENDPOINT(hostname).media.founditLogo}`}
          alt="Foundit Logo"
          className="h-6"
        />
      </div>
    </header>
  );
};

export default BasicHeader;
